var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m476.855 307.148-29.937-29.933-42.426 42.426 29.938 29.933c23.39 23.395 23.39 61.465 0 84.856-23.39 23.39-61.461 23.39-84.856 0L192.36 277.215l-42.425 42.426 157.214 157.214c46.86 46.86 122.848 46.86 169.707 0s46.86-122.847 0-169.707zm0 0",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.426 434.43c-23.395 23.39-61.465 23.39-84.856 0-23.39-23.39-23.39-61.461 0-84.856L234.785 192.36l-42.426-42.425L35.145 307.148c-46.86 46.86-46.86 122.848 0 169.707s122.847 46.86 169.707 0l29.933-29.937-42.426-42.426zM349.574 77.57c23.395-23.39 61.465-23.39 84.856 0 23.39 23.39 23.39 61.461 0 84.856L277.215 319.64l42.426 42.425 157.214-157.214c46.86-46.86 46.86-122.848 0-169.707s-122.847-46.86-169.707 0l-29.933 29.937 42.426 42.426zm0 0",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.082 234.785 42.426-42.426-29.938-29.933c-23.39-23.395-23.39-61.465 0-84.856 23.39-23.39 61.461-23.39 84.856 0l163.426 163.426 42.425-42.426L204.852 35.145c-46.86-46.86-122.848-46.86-169.707 0s-46.86 122.847 0 169.707zm0 0",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerLinkIcon);
export default __webpack_public_path__ + "static/media/server-link-icon.2dc49010b1f8c273e91e3750614be705.svg";
export { ForwardRef as ReactComponent };